import React from 'react';

const Blur = () => {
    return (
        <div id="blur"></div>
    );
}

export default Blur;